import { useEffect, useState } from "react";
import { App } from "./App";
import { api } from "./session-api";

type Setup =
  | { state: "loading" }
  | { state: "ready"; appId: string }
  | { state: "error"; message: string };

export function VkPlayBootstrap({ launchParams }: { launchParams: string }) {
  const [setup, setSetup] = useState<Setup>({ state: "loading" });
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let cancelled = false;
    setSetup({ state: "loading" });
    void api.vkPlayConfig().then(
      (config) => {
        if (cancelled) return;
        setSetup(
          config.enabled
            ? { state: "ready", appId: config.appId }
            : {
                state: "error",
                message: "Вход через VK Play недоступен.",
              },
        );
      },
      () => {
        if (!cancelled)
          setSetup({
            state: "error",
            message: "Не удалось подключиться к игре.",
          });
      },
    );
    return () => {
      cancelled = true;
    };
  }, [attempt]);
  if (setup.state === "ready")
    return (
      <App platform={{ kind: "vkplay", appId: setup.appId, launchParams }} />
    );
  return (
    <main className="connection-screen">
      <section className="connection-card panel" aria-live="polite">
        <span className="eyebrow">ФРОНТИР / VK PLAY</span>
        <h1>Последний сигнал</h1>
        <p>
          {setup.state === "loading" ? "Подключаем VK Play…" : setup.message}
        </p>
        {setup.state === "error" && (
          <button
            className="launch-button"
            onClick={() => setAttempt((value) => value + 1)}
          >
            Повторить подключение
          </button>
        )}
      </section>
    </main>
  );
}
